import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"facebook\"><path d=\"M29.803 24.737h-4.329V36h-4.41V24.737H18v-4.053h3.065v-3.463c0-2.723 1.807-5.221 5.977-5.221 1.688 0 2.936.159 2.936.159l-.098 3.783s-1.272-.012-2.66-.012c-1.506 0-1.746.674-1.746 1.792v2.962H30l-.197 4.053z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol